export enum OrderDeliveryState {
  NotTracking = "not_tracking",
  InArrival = "in_arrival",
  OnSite = "on_site",
  InDelivery = "in_delivery",
  Delivered = "delivered",
}
